<div class="footer-top rtl iran-sans">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 footer-contact">
                <div class="logo mb-4">
                    <a href="index.html"><img src="../../assets/img/drme-logo-text32.png" alt="" class="img-fluid"></a>
                </div>

                <div class="rtl row  w-100 iran-sans-fanum mr-2">
                    <span class="lnr lnr-envelope flip">
                    </span>
                    <p class="tel text pr-2 div-web-site">
                        <a href="mailto:info@drme.ir" class="website-address">info@drme.ir</a>
                    </p>
                </div>

                <div class="rtl row  w-100 iran-sans-fanum pt-3 mr-2">
                    <span class="lnr lnr-map-marker flip">
                    </span>
                    <p class="tel text pr-2">
                        خیابان شریعتی ، روبروی حسینیه ارشاد
                        <br>
                        کوچه هدیه، پلاک 15
                    </p>
                </div>

                <div class="rtl row pt-3 mr-2">
                    <div class="lnr lnr-phone-handset flip">
                    </div>
                    <div class="tel ltr iran-sans-fanum">021 - 75445</div>
                    <!-- <div class="tel iran-sans-fanum text">(60 خط)</div> -->
                </div>
            </div>

            <div class="col-lg-4 col-md-6 footer-links">
                <h4>لینک های مفید</h4>
                <ul>
                    <li><i class="bx bx-chevron-right"></i> <a href="#">صفحه اصلی</a></li>
                    <li><i class="bx bx-chevron-right"></i> <a href="#about">درباره ما</a></li>
                    <li><i class="bx bx-chevron-right"></i> <a href="http://ep.drme.ir">ورود پزشکان</a></li>
                    <li><i class="bx bx-chevron-right"></i> <a href="http://apt.drme.ir?login=true">ورود / عضویت</a></li>
                </ul>
            </div>

            <div class="col-lg-4 col-md-6 footer-links">
                <h4>خدمات ما</h4>
                <ul>
                    <li><i class="bx bx-chevron-right"></i> <a href="http://apt.drme.ir">نوبت دهی</a></li>
                    <li><i class="bx bx-chevron-right"></i> <a href="http://ep.drme.ir">نسخه نویسی</a></li>
                    <li><i class="bx bx-chevron-right"></i> <a href="#">بیماران من</a></li>
                </ul>
            </div>

            <!-- <div class="col-lg-2 col-md-6 footer-links">
                <h4>Our Social Networks</h4>
                <p>Cras fermentum odio eu feugiat lide par naso tierra videa magna derita valies</p>
                <div class="social-links mt-3">
                    <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                    <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                    <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                    <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                    <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                </div>
            </div> -->

        </div>
    </div>
</div>

<!-- <div class="container py-4">
    <div class="copyright">
        &copy; Copyright <strong><span>Ninestars</span></strong>. All Rights Reserved
    </div>
    <div class="credits">
        Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
    </div>
</div> -->